/* ResponsiveTabs.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _26 = "._1e0c116y{display:inline-flex}";
const _25 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _24 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _23 = "._1pbycs5v{z-index:2}";
const _22 = "._1xi2idpf{right:0}";
const _21 = "._kqswstnw{position:absolute}";
const _20 = "._lcxvglyw{pointer-events:none}";
const _19 = "._1bsb8pqr{width:2.5rem}";
const _18 = "._4t3i8pqr{height:2.5rem}";
const _17 = "._11q717ri{background:-webkit-linear-gradient(0deg,var(--_ux5vp5),var(--ds-background-input,#fff))}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { getTokenValue } from '@atlaskit/tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _16 = "._15peidpf::-webkit-scrollbar{height:0}";
const _15 = "@media not all and (min-width:48rem){._5f8cpxbi>div>[role=tab]:not(:last-of-type){margin-right:var(--ds-space-200,1pc)}}";
const _14 = "._eonrxy5q>div>[role=tab]:not(:last-of-type){margin-right:var(--ds-space-400,2pc)}";
const _13 = "@media (min-width:64rem){._ibqnu2gc>div>[role=tab]:first-of-type{margin-left:var(--ds-space-100,8px)}}";
const _12 = "._121z1pd9>div>[role=tab]{font-weight:var(--ds-font-weight-semibold,600)}";
const _11 = "._j67zyn4p>div>[role=tab]{height:2.75rem}";
const _10 = "._tr9o1k92>div>[role=tab]{line-height:1.25rem}";
const _9 = "._vz1a1h6o>div>[role=tab]{align-items:center}";
const _8 = "._ux2c1txw>div>[role=tab]{display:flex}";
const _7 = "._xvmw1j6v>div>[role=tab]{font-size:1rem}";
const _6 = "._1f6t1ns9>div>[role=tab]{min-width:-moz-fit-content;min-width:fit-content}";
const _5 = "@media (min-width:90rem){._1jru18iy>div>[role=tab]{padding:var(--ds-space-050,4px) var(--ds-space-100,8px)}}";
const _4 = "._rwqn18iy>div>[role=tab]{padding:var(--ds-space-050,4px) var(--ds-space-100,8px)}";
const _3 = "._1fjgglyw{scrollbar-width:none}";
const _2 = "._8am5i4x0{-webkit-overflow-scrolling:touch}";
const _ = "._1reo1wug{overflow-x:auto}";
export const TabListContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo1wug _8am5i4x0 _1fjgglyw _rwqn18iy _1jru18iy _1f6t1ns9 _xvmw1j6v _ux2c1txw _vz1a1h6o _tr9o1k92 _j67zyn4p _121z1pd9 _ibqnu2gc _eonrxy5q _5f8cpxbi _15peidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabListContainer.displayName = 'TabListContainer';
}
export const HorizontalScrollShadow = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _18, _19, _20, _21, _22, _23, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_ux5vp5": ix(getTokenValue('color.background.input') + 40)
      }),
      ref: __cmplr,
      className: ax(["_11q717ri _4t3i8pqr _1bsb8pqr _lcxvglyw _kqswstnw _1xi2idpf _1pbycs5v _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HorizontalScrollShadow.displayName = 'HorizontalScrollShadow';
}
export const StyledLozenge = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_25, _26]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0u2gc _1e0c116y", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledLozenge.displayName = 'StyledLozenge';
}